import { connect } from "react-redux";
import { createAssetLead } from "actions/assetLead";
import { closeModal } from "actions/modals";
import { push } from "connected-react-router";

import AssetLeadModal from "./AssetLeadModal";

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (assetLead) =>
    dispatch(createAssetLead(assetLead)).then((res) => {
      dispatch(closeModal("AssetLeadModal"));

      return dispatch(push(`/asset_leads/${res.value.assetLead.id}`));
    }),
});

export default connect(null, mapDispatchToProps)(AssetLeadModal);
